import React from 'react';
import { formatCardTypeImgPath } from 'Utils/Format';
import './CardInfo.css';

export const CardInfo = ({ cardNumber, cardType }) => {
  const lastFourDigits = cardNumber && cardNumber.substr(-4);
  const ccType = cardType && formatCardTypeImgPath(cardType);
  const cardImage = `/account/static/images/cards/ic-cc-${ccType}-01.svg`;

  if (lastFourDigits && ccType) {
    return <CardInfoView cardImage={cardImage} lastFourDigits={lastFourDigits} />;
  }
  return null;
};

export const CardInfoView = ({ cardImage, lastFourDigits }) => {
  return (
    <div className="cardInfo" data-dd-privacy="mask" data-heap-redact-text data-testid="cardInfoView">
      <img className="cardThumb" alt="cardThumb" width="53" height="35" src={cardImage} />
      <span className="hiddenNum">.... .... ....</span>
      <span className="lastFourDigit" data-testid="lastFourDigit">
        {lastFourDigits}
      </span>
    </div>
  );
};
